import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _construct from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Aug 06 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { Product, ProductCategory, ValidationError, UserMessageCode } from '@logio/common-be-fe';
import { List } from 'immutable';
import { action, observable, runInAction } from 'mobx';
import { FamilyLayer } from '../../transportLayers/family/FamilyLayer';
import { ProductCategoryLayer } from '../../transportLayers/product/ProductCategoryLayer';
import { ProductLayer } from '../../transportLayers/product/ProductLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * This store obtaining data of products.
 */

export var ProductStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(ProductStore, _BaseStore);

  function ProductStore(rootStore) {
    var _this;

    _classCallCheck(this, ProductStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductStore).call(this, rootStore));
    _this.name = StoreName.Product;
    _this.productLayer = new ProductLayer();
    _this.productCategoryLayer = new ProductCategoryLayer();
    _this.familyLayer = new FamilyLayer();
    _this.list = new Map();
    _this.units = new Map();
    _this.purchasePrices = new Map();

    _this.updateByfilter = function (filter) {
      return _this.productLayer.findByFilter(filter).then(function (products) {
        runInAction(function () {
          products.forEach(function (product) {
            if (product.id) {
              _this.list.set(product.id, product);
            }
          });
        });
        return products;
      });
    };

    _this.approvePriceSettings = function (id) {
      return _this.productLayer.approvePriceSettings(id).then(function (product) {
        runInAction(function () {
          _this.list.set(product.id, product);
        });
        return product;
      });
    };

    _this.setLeader = function (id) {
      return _this.productLayer.setLeader(id).then(function (products) {
        runInAction(function () {
          products.forEach(function (product) {
            if (product.id && _this.list.has(product.id)) {
              _this.list.set(product.id, product);
            }
          });
        });
        return products;
      });
    };

    return _this;
  }

  _createClass(ProductStore, [{
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      this.list.clear();
      return this.productLayer.findAll().then(function (products) {
        runInAction(function () {
          products.forEach(function (product) {
            if (product.id) {
              _this2.list.set(product.id, product);
            }
          });
        });
      });
    }
  }, {
    key: "filter",
    value: function filter(_filter) {
      var _this3 = this;

      this.list.clear();
      return this.productLayer.findByFilter(_filter).then(function (products) {
        runInAction(function () {
          products.forEach(function (product) {
            if (product.id) {
              _this3.list.set(product.id, product);
            }
          });
        });
      });
    }
  }, {
    key: "getInCategory",
    value: function getInCategory(categoryId) {
      var _this4 = this;

      this.list.clear();
      return this.productLayer.findInCategory(categoryId).then(function (products) {
        runInAction(function () {
          products.forEach(function (product) {
            if (product.id) {
              _this4.list.set(product.id, product);
            }
          });
        });
      });
    }
  }, {
    key: "getPurchasePriceInCategory",
    value: function getPurchasePriceInCategory(categoryId) {
      var _this5 = this;

      return this.productLayer.findPurchasePriceInCategory(categoryId).then(function (prices) {
        prices.forEach(function (price) {
          if (price.productId) {
            runInAction(function () {
              _this5.purchasePrices.set(price.productId, price.purchasePrice);
            });
          }
        });
      });
    }
  }, {
    key: "getOne",
    value: function getOne(productId) {
      var _this6 = this;

      return this.productLayer.findOne(productId).then(function (product) {
        runInAction(function () {
          _this6.list.set(product.id, product);
        });
        return product;
      });
    }
  }, {
    key: "update",
    value: function update(product) {
      var _this7 = this;

      return this.productLayer.update(product).then(function (prod) {
        runInAction(function () {
          _this7.list.set(prod.id, prod);
        });
      });
    }
  }, {
    key: "updateTier",
    value: function updateTier(updates) {
      var _this8 = this;

      return this.productLayer.updateTier(updates).then(function (products) {
        runInAction(function () {
          products.forEach(function (product) {
            if (product.id) {
              _this8.list.set(product.id, product);
            }
          });
        });
      });
    }
  }, {
    key: "updateSensitivity",
    value: function updateSensitivity(updates) {
      var _this9 = this;

      return this.productLayer.updateSensitivity(updates).then(function (products) {
        runInAction(function () {
          products.forEach(function (product) {
            if (product.id) {
              _this9.list.set(product.id, product);
            }
          });
        });
      });
    }
  }, {
    key: "removeFamily",
    value: function removeFamily(productIds) {
      var _this10 = this;

      return this.familyLayer.unassignProducts(productIds).then(function (products) {
        runInAction(function () {
          products.forEach(function (product) {
            if (product.id) {
              _this10.list.set(product.id, product);
            }
          });
        });
      });
    }
  }, {
    key: "assignToFamily",
    value: function assignToFamily(familyId, bindings) {
      var _this11 = this;

      return this.productLayer.assignToFamily(familyId, bindings).then(function (products) {
        runInAction(function () {
          products.forEach(function (product) {
            if (product.id && _this11.list.has(product.id)) {
              _this11.list.set(product.id, product);
            }
          });

          var familyStore = _this11.rootStore.getStore(StoreName.Family);

          familyStore.getOne(familyId);
        });
      });
    }
  }, {
    key: "getUnits",
    value: function getUnits() {
      var _this12 = this;

      return this.productLayer.findUnits().then(function (units) {
        runInAction(function () {
          units.forEach(function (unit) {
            _this12.units.set(unit.id, unit);
          });
        });
      });
    }
  }, {
    key: "priceArchitectureExport",
    value: function priceArchitectureExport() {
      return this.productLayer.priceArchitectureExport();
    }
  }, {
    key: "dataCleaningExport",
    value: function dataCleaningExport() {
      return this.productLayer.dataCleaningExport();
    }
  }, {
    key: "dataPairingExport",
    value: function dataPairingExport() {
      return this.productLayer.dataPairingExport();
    }
  }, {
    key: "releaseDetailExport",
    value: function releaseDetailExport(releaseId) {
      return this.productLayer.releaseDetailExport(releaseId);
    }
  }, {
    key: "releaseSelloutDetailExport",
    value: function releaseSelloutDetailExport(releaseId) {
      return this.productLayer.releaseSelloutDetailExport(releaseId);
    }
  }, {
    key: "siteReleaseDetailExport",
    value: function siteReleaseDetailExport(releaseId) {
      return this.productLayer.siteReleaseDetailExport(releaseId);
    }
  }, {
    key: "validate",
    value: function validate(productExternalIds, additionalFilter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var validationErrors, invalidIds, validationError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!productExternalIds) {
                  _context.next = 8;
                  break;
                }

                _context.next = 3;
                return this.productLayer.validateByExternalIds(productExternalIds, Object.assign({
                  activeUnaware: true
                }, additionalFilter));

              case 3:
                validationErrors = _context.sent;

                if (!validationErrors.size) {
                  _context.next = 8;
                  break;
                }

                // aggregate message args (invalid product ids) into one validation error
                invalidIds = validationErrors.map(function (err) {
                  return err.messageArgs[0];
                });
                validationError = _construct(ValidationError, [UserMessageCode.ProductNotFound].concat(_toConsumableArray(invalidIds)));
                return _context.abrupt("return", validationError);

              case 8:
                return _context.abrupt("return", undefined);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return ProductStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", ProductCategory)], ProductStore.prototype, "productCategory", void 0);

__decorate([observable, __metadata("design:type", Map)], ProductStore.prototype, "list", void 0);

__decorate([observable, __metadata("design:type", Map)], ProductStore.prototype, "units", void 0);

__decorate([observable, __metadata("design:type", Map)], ProductStore.prototype, "purchasePrices", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], ProductStore.prototype, "getAll", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], ProductStore.prototype, "filter", null);

__decorate([action, __metadata("design:type", Object)], ProductStore.prototype, "updateByfilter", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], ProductStore.prototype, "getInCategory", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], ProductStore.prototype, "getPurchasePriceInCategory", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], ProductStore.prototype, "getOne", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Product]), __metadata("design:returntype", Promise)], ProductStore.prototype, "update", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], ProductStore.prototype, "updateTier", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], ProductStore.prototype, "updateSensitivity", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Array]), __metadata("design:returntype", Promise)], ProductStore.prototype, "removeFamily", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object, Array]), __metadata("design:returntype", Promise)], ProductStore.prototype, "assignToFamily", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], ProductStore.prototype, "getUnits", null);

__decorate([action, __metadata("design:type", Object)], ProductStore.prototype, "approvePriceSettings", void 0);

__decorate([action, __metadata("design:type", Object)], ProductStore.prototype, "setLeader", void 0);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], ProductStore.prototype, "priceArchitectureExport", null);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], ProductStore.prototype, "dataCleaningExport", null);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], ProductStore.prototype, "dataPairingExport", null);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], ProductStore.prototype, "releaseDetailExport", null);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], ProductStore.prototype, "releaseSelloutDetailExport", null);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], ProductStore.prototype, "siteReleaseDetailExport", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object, Object]), __metadata("design:returntype", Promise)], ProductStore.prototype, "validate", null);